function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 19,
  r: 19,
  fill: "#C4C4C4"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 19,
  r: 19,
  fill: "url(#paint0_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 19,
  r: 19,
  fill: "url(#paint1_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 19,
  r: 19,
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 38,
  height: 38
}, /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 19,
  r: 19,
  fill: "#C4C4C4"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 19,
  r: 19,
  fill: "url(#paint2_linear)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 19,
  r: 19,
  fill: "url(#paint3_linear)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 19,
  r: 19,
  fill: "white"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.8965 26.8287V25.0108C23.8965 24.0465 23.5134 23.1217 22.8316 22.4399C22.1497 21.7581 21.225 21.375 20.2607 21.375H12.9891C12.0248 21.375 11.1 21.7581 10.4182 22.4399C9.73633 23.1217 9.35327 24.0465 9.35327 25.0108V26.8287",
  stroke: "#AC04B1",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.6248 17.7391C18.6328 17.7391 20.2606 16.1113 20.2606 14.1033C20.2606 12.0953 18.6328 10.4675 16.6248 10.4675C14.6168 10.4675 12.989 12.0953 12.989 14.1033C12.989 16.1113 14.6168 17.7391 16.6248 17.7391Z",
  stroke: "#AC04B1",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.3501 26.8286V25.0107C29.3495 24.2051 29.0814 23.4225 28.5879 22.7859C28.0943 22.1492 27.4033 21.6944 26.6233 21.493",
  stroke: "#AC04B1",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.9875 10.5857C23.7696 10.7859 24.4628 11.2408 24.9578 11.8785C25.4528 12.5162 25.7215 13.3006 25.7215 14.1079C25.7215 14.9152 25.4528 15.6995 24.9578 16.3372C24.4628 16.975 23.7696 17.4298 22.9875 17.6301",
  stroke: "#AC04B1",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 14.1655,
  y1: 18.9967,
  x2: 39.846,
  y2: 18.9967,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C800CA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7D25CF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 32.8453,
  y1: -3.12632,
  x2: 17.8651,
  y2: 33.1345,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#003FBF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.07,
  stopColor: "#1E39C3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#3B33C7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  stopColor: "#532ECA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.37,
  stopColor: "#662ACC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#7327CE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#7B25CF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7D25CF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 14.1655,
  y1: 18.9967,
  x2: 39.846,
  y2: 18.9967,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C800CA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7D25CF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 32.8453,
  y1: -3.12632,
  x2: 17.8651,
  y2: 33.1345,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#003FBF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.07,
  stopColor: "#1E39C3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#3B33C7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  stopColor: "#532ECA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.37,
  stopColor: "#662ACC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#7327CE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#7B25CF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7D25CF"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 21.8148,
  height: 21.8148,
  fill: "white",
  transform: "translate(8.44434 7.74072)"
})));

function SvgHrActive(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

export default "data:image/svg+xml;base64,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";
export { SvgHrActive as ReactComponent };